<template>
    <v-form :disabled="loading || disabled">
        <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
        <v-col cols="12" xl="10" class="px-0">
            <v-row v-if="!loading && !user.id">
                <v-col cols="12">
                    <b-alert :message="t('users::create.account_activation.info')"> </b-alert>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" class="pb-0">
                    <h5>{{ t('dms-users::form.title.general_information') }}</h5>
                </v-col>
                <v-col cols="12" lg="6" class="py-0">
                    <b-input
                        to-mutate="dms_users::dms_user.username"
                        :label="t('dms-users::form.label.username')"
                        :rules="validationRules.username"
                        :readonly="readOnlyRules"
                        mandatory
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="pt-0">
                    <b-select
                        to-mutate="dms_users::dms_user.status"
                        :label="t('dms-users::form.label.status')"
                        :select-items="statusOptions"
                        :rules="validationRules.status"
                        :readonly="readOnlyRules"
                        mandatory
                    ></b-select>
                </v-col>
                <v-col cols="12" lg="6" class="pt-0">
                    <b-input
                        to-mutate="dms_users::dms_user.surname"
                        :label="t('dms-users::form.label.surname')"
                        :rules="validationRules.surname"
                        :readonly="readOnlyRules"
                        mandatory
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="pt-0">
                    <b-input
                        to-mutate="dms_users::dms_user.forename"
                        :label="t('dms-users::form.label.forename')"
                        :rules="validationRules.forename"
                        :readonly="readOnlyRules"
                        mandatory
                    ></b-input>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" class="pb-0">
                    <h5>{{ t('dms-users::form.title.address') }}</h5>
                </v-col>
                <v-col cols="12" lg="6" class="py-0">
                    <b-input
                        to-mutate="dms_users::dms_user.address"
                        :label="t('dms-users::form.label.address')"
                        :rules="validationRules.address"
                        :readonly="readOnlyRules"
                        mandatory
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="py-0">
                    <b-input
                        to-mutate="dms_users::dms_user.post_code"
                        :label="t('dms-users::form.label.post_code')"
                        :rules="validationRules.post_code"
                        mandatory
                        :readonly="readOnlyRules"
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="py-0">
                    <b-input
                        to-mutate="dms_users::dms_user.second_address"
                        :label="t('dms-users::form.label.second_address')"
                        :readonly="readOnlyRules"
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="pt-0">
                    <b-input
                        clearable
                        to-mutate="dms_users::dms_user.country"
                        :label="t('dms-users::form.label.country')"
                        :readonly="readOnlyRules"
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="pt-0">
                    <b-input
                        clearable
                        to-mutate="dms_users::dms_user.region"
                        :label="t('dms-users::form.label.county')"
                        :readonly="readOnlyRules"
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="pt-0">
                    <b-input
                        clearable
                        to-mutate="dms_users::dms_user.town"
                        :label="t('dms-users::form.label.town')"
                        :readonly="readOnlyRules"
                    ></b-input>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <h5>{{ t('dms-users::form.title.contact_details') }}</h5>
                </v-col>
                <v-col cols="12" lg="6" class="py-0">
                    <b-input
                        to-mutate="dms_users::dms_user.phone"
                        :label="t('dms-users::form.label.phone')"
                        :rules="validationRules.phone"
                        mandatory
                        :readonly="readOnlyRules"
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="py-0">
                    <b-input
                        to-mutate="dms_users::dms_user.fax"
                        :label="t('dms-users::form.label.fax')"
                        :rules="validationRules.fax"
                        :readonly="readOnlyRules"
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="pt-0">
                    <b-input
                        to-mutate="dms_users::dms_user.email"
                        :label="t('dms-users::form.label.email')"
                        :rules="validationRules.email"
                        :readonly="readOnlyRules"
                        mandatory
                    ></b-input>
                </v-col>
            </v-row>
        </v-col>
    </v-form>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            validationRules: {
                username: [(v) => !!v || t('users::validation.field.required')],
                surname: [(v) => !!v || t('users::validation.field.required')],
                forename: [(v) => !!v || t('users::validation.field.required')],
                address: [(v) => !!v || t('users::validation.field.required')],
                status: [(v) => !!v || t('users::validation.field.required')],
                post_code: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.postCode],
                phone: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.phone],
                fax: [this.$root.rules.fax],
                email: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.email],
            },
            statusOptions: [
                {
                    text: t('users::options.status.active'),
                    value: 'active',
                },
                {
                    text: t('users::options.status.blocked'),
                    value: 'blocked',
                },
                {
                    text: t('users::options.status.suspended'),
                    value: 'suspended',
                },
            ],
            readOnlyRules:
                !(this.can('api.v1.dms-users.update') || this.can('api.v1.dms-users.store')) &&
                this.can('api.v1.dms-users.show'),
        };
    },
    computed: {
        user() {
            return this.$store.state.dms_users.dms_user;
        },
        loading() {
            return this.$store.state.dms_users.loading;
        },
    },
};
</script>

<style></style>
